import React from 'react'
import PropTypes from 'prop-types'
import SlickSlider from 'react-slick'
import ArrowIcon from 'assets/svgs/arrow.svg'
import * as S from './Slider.styles'

const defaultSettings = {
  arrows: true,
  nextArrow: (
    <S.ArrowRight>
      <ArrowIcon />
    </S.ArrowRight>
  ),
  prevArrow: (
    <S.ArrowLeft>
      <ArrowIcon />
    </S.ArrowLeft>
  ),
}

const Slider = ({ children, settings, asNavFor, sliderRef }) => (
  <S.Wrapper>
    <SlickSlider
      ref={sliderRef}
      asNavFor={asNavFor}
      {...defaultSettings}
      {...settings}
    >
      {children}
    </SlickSlider>
  </S.Wrapper>
)

Slider.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object.isRequired,
  sliderRef: PropTypes.object,
  asNavFor: PropTypes.object,
}

Slider.defaultProps = {
  sliderRef: null,
  asNavFor: null,
}

export default Slider
